import cx from 'classnames';
import OtpInput from 'react-otp-input';

import { LrvOTPInputProps } from '../../interfaces/lrvOtpInput';

import styles from './LrvOtpInput.module.scss';

export const LrvOtpInput = (props: LrvOTPInputProps) => {
  const { theme = 'dark', numInputs = 6 } = props;
  const isDarkTheme = theme === 'dark';

  const lrvProps = {
    ...props,
    numInputs
  };

  return (
    <div className={cx(styles.container, isDarkTheme ? styles.darkContainer : styles.lightContainer)}>
      <OtpInput {...lrvProps} />
    </div>
  );
};
